import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { BrandLogo } from '@/components/BrandLogo';

const navLinks = [
{ name: 'Home', href: '/' },
{ name: 'Sponsorship', href: '/sponsors' },
{ name: 'Events', href: '/events' },
{ name: 'Latest Jobs', href: '/jobs' },
{ name: 'Properties', href: '/properties' },
{ name: 'Directory', href: '/directory' },
{ name: 'News', href: '/news' },
{ name: 'Contact', href: '/contact' }];


export const Navbar = ({ transparent = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      transparent ? 'bg-transparent' : 'bg-slate-900/95 backdrop-blur-md border-b border-white/10'}`
      }
      data-testid="navbar">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-testid="nav-logo">
            <BrandLogo size="md" variant="light" className="sm:hidden" />
            <BrandLogo size="lg" variant="light" className="hidden sm:inline-flex" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) =>
            <Link
              key={link.name}
              to={link.href}
              data-testid={`nav-${link.name.toLowerCase()}`}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              isActive(link.href) ?
              'text-sky-400 bg-white/10' :
              'text-slate-300 hover:text-white hover:bg-white/5'}`
              }>

                {link.name}
              </Link>
            )}
            <Link to="/sponsors" data-testid="nav-become-sponsor">
              <Button className="ml-4 bg-sky-500 hover:bg-sky-600 text-white shadow-lg shadow-sky-500/25">
                Become a Sponsor
                <ChevronRight className="ml-1 h-4 w-4" />
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white p-2"
              data-testid="nav-mobile-menu">

              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen &&
      <div className="md:hidden bg-slate-900/98 backdrop-blur-lg border-t border-white/10">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) =>
          <Link
            key={link.name}
            to={link.href}
            onClick={() => setIsOpen(false)}
            className={`block px-4 py-3 rounded-md text-base font-medium ${
            isActive(link.href) ?
            'text-sky-400 bg-white/10' :
            'text-slate-300 hover:text-white hover:bg-white/5'}`
            }>

                {link.name}
              </Link>
          )}
            <Link
            to="/sponsors"
            onClick={() => setIsOpen(false)}
            className="block mt-4">

              <Button className="w-full bg-sky-500 hover:bg-sky-600 text-white">
                Become a Sponsor
              </Button>
            </Link>
          </div>
        </div>
      }
    </nav>);

};

export default Navbar;